module.exports = __webpack_public_path__ + "img/tarj-des-myfip.b02bb094.png";